import { USER_TYPES } from '../constants';
import { ADMIN_ROUTES, WAREHOUSE_ROUTES } from '../constants/routes';

/**
 * Utility functions for route protection based on user application type
 */

export const getUserApplicationType = (): string | null => {
  try {
    const application = localStorage.getItem('application');
    return application ? JSON.parse(application) : null;
  } catch (error) {
    console.error('Error parsing application type from localStorage:', error);
    return null;
  }
};

export const isERPUser = (): boolean => {
  const applicationType = getUserApplicationType();
  return applicationType === USER_TYPES.REGULAR;
};

export const isWarehouseUser = (): boolean => {
  const applicationType = getUserApplicationType();
  return applicationType === USER_TYPES.WAREHOUSE;
};

export const getDefaultRedirectPath = (): string => {
  const applicationType = getUserApplicationType();

  if (applicationType === USER_TYPES.REGULAR) {
    return ADMIN_ROUTES.dashboardPage;
  } else if (applicationType === USER_TYPES.WAREHOUSE) {
    return WAREHOUSE_ROUTES.inboundPackages;
  }

  // If no application type is set, redirect to admin sign in
  return ADMIN_ROUTES.adminSignIn;
};
